import GenericCloneComponent from './GenericCloneComponent'

export default GenericCloneComponent
